import { render } from "./TermosDeUso.vue?vue&type=template&id=e999796e&scoped=true"
import script from "./TermosDeUso.vue?vue&type=script&lang=js"
export * from "./TermosDeUso.vue?vue&type=script&lang=js"

import "./TermosDeUso.vue?vue&type=style&index=0&id=e999796e&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e999796e"]])

export default __exports__